import { render } from "./newUser.vue?vue&type=template&id=b5647fb0&scoped=true"
import script from "./newUser.vue?vue&type=script&lang=js"
export * from "./newUser.vue?vue&type=script&lang=js"

import "./newUser.vue?vue&type=style&index=0&id=b5647fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5647fb0"]])

export default __exports__